import {
    GETOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS,
    CREATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS,
    UPDATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS,
    DELETEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS,
    GETOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE,
    CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE,
    UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE,
    DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE,
    GETOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY,
    CREATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY,
    UPDATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY,
    DELETEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY,
    GETOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY,
    CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY,
    UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY,
    DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY,
    GETOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY,
    CREATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY,
    UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY,
    DELETEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY,
    GETOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE,
    CREATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE,
    UPDATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE,
    DELETEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE,
    CLEAROPTHALMOLOGYOPDPROCEDURENEWGLASS,
    CLEAROPTHALMOLOGYOPDPROCEDURECONTACTLENSE,
    CLEAROPTHALMOLOGYOPDPROCEDUREREFRACTIVESURGERY,
    CLEAROPTHALMOLOGYOPDPROCEDURECONTRACTSURGERY,
    CLEAROPTHALMOLOGYOPDPROCEDURECORNEALSURGERY,
    CLEAROPTHALMOLOGYOPDPROCEDURELASIKPROCEDURE,
    GETOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS,
    CLEAROPTHALMOLOGYOPDCOUNSSURGERYDETAILS,
    CREATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS,
    UPDATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS,
    DELETEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS,
    GETOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM,
    CLEAROPTHALMOLOGYOPDCOUNSCOUNSELLORFORM,
    CREATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM,
    UPDATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM,
    DELETEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM,
    GETOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE,
    CLEAROPTHALMOLOGYOPDCOUNSEASTIMATE,
    CREATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE,
    UPDATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE,
    DELETEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE,
    GETOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE,
    CLEAROPTHALMOLOGYOPDCOUNSSCHEDULE,
    CREATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE,
    UPDATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE,
    DELETEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE,
    GETOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION,
    CLEAROPTHALMOLOGYOPDCOUNSINSTRUCTION,
    CREATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION,
    UPDATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION,
    DELETEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION,
    GETOPHTHALMOLOGYOPDOUTDRLASH,
    CREATEOPHTHALMOLOGYOPDOUTDRLASH,
    UPDATEOPHTHALMOLOGYOPDOUTDRLASH,
    DELETEOPHTHALMOLOGYOPDOUTDRLASH,
    GETOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA,
    CREATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA,
    UPDATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA,
    DELETEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA,
    GETOPHTHALMOLOGYOPDOUTDRCORNEA,
    CREATEOPHTHALMOLOGYOPDOUTDRCORNEA,
    UPDATEOPHTHALMOLOGYOPDOUTDRCORNEA,
    DELETEOPHTHALMOLOGYOPDOUTDRCORNEA,
    GETOPHTHALMOLOGYOPDOUTDRIRIS,
    CREATEOPHTHALMOLOGYOPDOUTDRIRIS,
    UPDATEOPHTHALMOLOGYOPDOUTDRIRIS,
    DELETEOPHTHALMOLOGYOPDOUTDRIRIS,
    GETOPHTHALMOLOGYOPDOUTDRPUPIL,
    CREATEOPHTHALMOLOGYOPDOUTDRPUPIL,
    UPDATEOPHTHALMOLOGYOPDOUTDRPUPIL,
    DELETEOPHTHALMOLOGYOPDOUTDRPUPIL,
    GETOPHTHALMOLOGYOPDOUTDRLENSE,
    CREATEOPHTHALMOLOGYOPDOUTDRLENSE,
    UPDATEOPHTHALMOLOGYOPDOUTDRLENSE,
    DELETEOPHTHALMOLOGYOPDOUTDRLENSE,
    GETOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION,
    CREATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION,
    UPDATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION,
    DELETEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION,
    GETOPHTHALMOLOGYOPDOUTDRPACHYMETRY,
    CREATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY,
    UPDATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY,
    DELETEOPHTHALMOLOGYOPDOUTDRPACHYMETRY,
    GETOPHTHALMOLOGYOPDOUTDRIOP,
    CREATEOPHTHALMOLOGYOPDOUTDRIOP,
    UPDATEOPHTHALMOLOGYOPDOUTDRIOP,
    DELETEOPHTHALMOLOGYOPDOUTDRIOP,
    GETOPHTHALMOLOGYOPDOUTDRDRAWING,
    CREATEOPHTHALMOLOGYOPDOUTDRDRAWING,
    UPDATEOPHTHALMOLOGYOPDOUTDRDRAWING,
    DELETEOPHTHALMOLOGYOPDOUTDRDRAWING,
    GETOPHTHALMOLOGYOPDOUTDRGONIOSCOPY,
    CREATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY,
    UPDATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY,
    DELETEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY,
    GETOPHTHALMOLOGYOPDOUTDRDOCTOR,
    CREATEOPHTHALMOLOGYOPDOUTDRDOCTOR,
    UPDATEOPHTHALMOLOGYOPDOUTDRDOCTOR,
    DELETEOPHTHALMOLOGYOPDOUTDRDOCTOR,
    GETOPHTHALMOLOGYOPDOUTDRDIAGNOSIS,
    CREATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS,
    UPDATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS,
    DELETEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS,
    GETOPHTHALMOLOGYOPDOUTDRSURGERYADVICE,
    CREATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE,
    UPDATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE,
    DELETEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE,
    CLEAROPTHALMOLOGYOPDDRLASH,
    CLEAROPTHALMOLOGYOPDDRCONJUNCTIVA,
    CLEAROPTHALMOLOGYOPDDRCORNEA,
    CLEAROPTHALMOLOGYOPDDRIRIS,
    CLEAROPTHALMOLOGYOPDDRPUPIL,
    CLEAROPTHALMOLOGYOPDDRLENSE,
    CLEAROPTHALMOLOGYOPDDRGLASSPRESCRIPTION,
    CLEAROPTHALMOLOGYOPDDRPACHYMETRY,
    CLEAROPTHALMOLOGYOPDDRIOP,
    CLEAROPTHALMOLOGYOPDDRDRAWING,
    CLEAROPTHALMOLOGYOPDDRGONIOSCOPY,
    CLEAROPTHALMOLOGYOPDDRDOCTOR,
    CLEAROPTHALMOLOGYOPDDRDIAGNOSIS,
    CLEAROPTHALMOLOGYOPDDRSURGERYADVICE,
    CLEAROPTHALMOLOGYOPDCHIEFCOMPLAINT,
    CLEAROPTHALMOLOGYOPDPASTOCCULARHIST,
    CLEAROPTHALMOLOGYOPDSYSTEMICILLNESS,
    CLEAROPTHALMOLOGYOPDFAMILYHIST,
    CLEAROPTHALMOLOGYOPDALLERGYHIST,
    CLEAROPTHALMOLOGYOPDDIABETIC,
    CLEAROPTHALMOLOGYOPDCOMPLAINTTEXTBOX,
    CLEAROPTHALMOLOGYOPDVISION,
    CLEAROPTHALMOLOGYOPDREFRACTION,
    CLEAROPTHALMOLOGYOPDPRESCRIPTION,
    CLEAROPTHALMOLOGYOPDASCAN,
    CLEAROPTHALMOLOGYOPDCOVERTESTEOM,
    CLEAROPTHALMOLOGYOPDKERATOMETRY,
    CLEAROPTHALMOLOGYOPDPACHYMETRY,
    CLEAROPTHALMOLOGYOPDSYRINGING,
    CLEAROPTHALMOLOGYOPDOUTIOP,
    CLEAROPTHALMOLOGYOPDCOLORVISION,
    CLEAROPTHALMOLOGYOPDFUNDUS,
    CLEAROPTHALMOLOGYOPDGLAUCOMA,
    GETOPHTHALMOLOGYOPDOUTREFRACTIONS,
    CREATEOPHTHALMOLOGYOPDOUTREFRACTIONS,
    UPDATEOPHTHALMOLOGYOPDOUTREFRACTIONS,
    DELETEOPHTHALMOLOGYOPDOUTREFRACTIONS,
    GETOPHTHALMOLOGYOPDOUTASCAN,
    CREATEOPHTHALMOLOGYOPDOUTASCAN,
    UPDATEOPHTHALMOLOGYOPDOUTASCAN,
    DELETEOPHTHALMOLOGYOPDOUTASCAN,
    GETOPHTHALMOLOGYOPDOUTCOVERTESTEOM,
    CREATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM,
    UPDATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM,
    DELETEOPHTHALMOLOGYOPDOUTCOVERTESTEOM,
    GETOPHTHALMOLOGYOPDOUTKERATOMETRY,
    CREATEOPHTHALMOLOGYOPDOUTKERATOMETRY,
    UPDATEOPHTHALMOLOGYOPDOUTKERATOMETRY,
    DELETEOPHTHALMOLOGYOPDOUTKERATOMETRY,
    GETOPHTHALMOLOGYOPDOUTPACHYMETRY,
    CREATEOPHTHALMOLOGYOPDOUTPACHYMETRY,
    UPDATEOPHTHALMOLOGYOPDOUTPACHYMETRY,
    DELETEOPHTHALMOLOGYOPDOUTPACHYMETRY,
    GETOPHTHALMOLOGYOPDOUTSYRINGING,
    CREATEOPHTHALMOLOGYOPDOUTSYRINGING,
    UPDATEOPHTHALMOLOGYOPDOUTSYRINGING,
    DELETEOPHTHALMOLOGYOPDOUTSYRINGING,
    GETOPHTHALMOLOGYOPDOUTIOP,
    CREATEOPHTHALMOLOGYOPDOUTIOP,
    UPDATEOPHTHALMOLOGYOPDOUTIOP,
    DELETEOPHTHALMOLOGYOPDOUTIOP,
    GETOPHTHALMOLOGYOPDOUTCOLORVISION,
    CREATEOPHTHALMOLOGYOPDOUTCOLORVISION,
    UPDATEOPHTHALMOLOGYOPDOUTCOLORVISION,
    DELETEOPHTHALMOLOGYOPDOUTCOLORVISION,
    GETOPHTHALMOLOGYOPDOUTFUNDUS,
    CREATEOPHTHALMOLOGYOPDOUTFUNDUS,
    UPDATEOPHTHALMOLOGYOPDOUTFUNDUS,
    DELETEOPHTHALMOLOGYOPDOUTFUNDUS,
    GETOPHTHALMOLOGYOPDOUTGLAUCOMA,
    CREATEOPHTHALMOLOGYOPDOUTGLAUCOMA,
    UPDATEOPHTHALMOLOGYOPDOUTGLAUCOMA,
    DELETEOPHTHALMOLOGYOPDOUTGLAUCOMA,
    GETOPHTHALMOLOGYOPDOUTVISIONCHART2,
    CREATEOPHTHALMOLOGYOPDOUTVISIONCHART2,
    UPDATEOPHTHALMOLOGYOPDOUTVISIONCHART2,
    DELETEOPHTHALMOLOGYOPDOUTVISIONCHART2,
    GETOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION,
    CREATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION,
    UPDATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION,
    DELETEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC,
    GETOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX,
    CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX,
    UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX,
    DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX,
    GETOPHTHALMOLOGYOPDVISIONCHART,
    CREATEOPHTHALMOLOGYOPDVISIONCHART,
    UPDATEOPHTHALMOLOGYOPDVISIONCHART,
    DELETEOPHTHALMOLOGYOPDVISIONCHART,
    GETOPHTHALMOLOGYOPDREFRACTION,
    CREATEOPHTHALMOLOGYOPDREFRACTION,
    UPDATEOPHTHALMOLOGYOPDREFRACTION,
    DELETEOPHTHALMOLOGYOPDREFRACTION,
    GETOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION,
    CREATEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION,
    UPDATEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION,
    DELETEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION,
    GETOPHTHALMOLOGYOPDASCAN,
    CREATEOPHTHALMOLOGYOPDASCAN,
    UPDATEOPHTHALMOLOGYOPDASCAN,
    DELETEOPHTHALMOLOGYOPDASCAN,
    GETOPHTHALMOLOGYOPDCOVERTESTEOM,
    CREATEOPHTHALMOLOGYOPDCOVERTESTEOM,
    UPDATEOPHTHALMOLOGYOPDCOVERTESTEOM,
    DELETEOPHTHALMOLOGYOPDCOVERTESTEOM,
    GETOPHTHALMOLOGYOPDKERATOMETRY,
    CREATEOPHTHALMOLOGYOPDKERATOMETRY,
    UPDATEOPHTHALMOLOGYOPDKERATOMETRY,
    DELETEOPHTHALMOLOGYOPDKERATOMETRY,
    GETOPHTHALMOLOGYOPDPACHYMETRY,
    CREATEOPHTHALMOLOGYOPDPACHYMETRY,
    UPDATEOPHTHALMOLOGYOPDPACHYMETRY,
    DELETEOPHTHALMOLOGYOPDPACHYMETRY,
    GETOPHTHALMOLOGYOPDSYRINGING,
    CREATEOPHTHALMOLOGYOPDSYRINGING,
    UPDATEOPHTHALMOLOGYOPDSYRINGING,
    DELETEOPHTHALMOLOGYOPDSYRINGING,
    GETOPHTHALMOLOGYOPDIOP,
    CREATEOPHTHALMOLOGYOPDIOP,
    UPDATEOPHTHALMOLOGYOPDIOP,
    DELETEOPHTHALMOLOGYOPDIOP,
    GETOPHTHALMOLOGYOPDCOLORVISION,
    CREATEOPHTHALMOLOGYOPDCOLORVISION,
    UPDATEOPHTHALMOLOGYOPDCOLORVISION,
    DELETEOPHTHALMOLOGYOPDCOLORVISION,
    GETOPHTHALMOLOGYOPDFUNDUS,
    CREATEOPHTHALMOLOGYOPDFUNDUS,
    UPDATEOPHTHALMOLOGYOPDFUNDUS,
    DELETEOPHTHALMOLOGYOPDFUNDUS,
    GETOPHTHALMOLOGYOPDGLAUCOMA,
    CREATEOPHTHALMOLOGYOPDGLAUCOMA,
    UPDATEOPHTHALMOLOGYOPDGLAUCOMA,
    DELETEOPHTHALMOLOGYOPDGLAUCOMA,

} from "../actions/types"

const initialState = {};

export default function EyeOphthalmologyOpdReducer(state = initialState, action) {
    switch (action.type) {

        case GETOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION:
            return { ...state, EyeOphthalmologyGlassLensePrescriptionList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION:
            return { ...state, EyeOphthalmologyGlassLensePrescriptionSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION:
            return { ...state, EyeOphthalmologyGlassLensePrescriptionUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION:
            return { ...state, EyeOphthalmologyGlassLensePrescriptionDeleteStatus: action.payload.success, }

        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT:
            return { ...state, OphthalmologyOPDComplaintChiefHistList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT:
            return { ...state, OphthalmologyOPDComplaintChiefHistSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT:
            return { ...state, OphthalmologyOPDComplaintChiefHistUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT:
            return { ...state, OphthalmologyOPDComplaintChiefHistDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST:
            return { ...state, OphthalmologyOPDComplaintPastOccularHistList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST:
            return { ...state, OphthalmologyOPDComplaintPastOccularHistSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST:
            return { ...state, OphthalmologyOPDComplaintPastOccularHistUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST:
            return { ...state, OphthalmologyOPDComplaintPastOccularHistDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS:
            return { ...state, OphthalmologyOPDComplaintSystemicIllnessList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS:
            return { ...state, OphthalmologyOPDComplaintSystemicIllnessSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS:
            return { ...state, OphthalmologyOPDComplaintSystemicIllnessUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS:
            return { ...state, OphthalmologyOPDComplaintSystemicIllnessDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST:
            return { ...state, OphthalmologyOPDComplaintFamilyHistList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST:
            return { ...state, OphthalmologyOPDComplaintFamilyHistSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST:
            return { ...state, OphthalmologyOPDComplaintFamilyHistUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST:
            return { ...state, OphthalmologyOPDComplaintFamilyHistDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST:
            return { ...state, OphthalmologyOPDComplaintAllergyHistList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST:
            return { ...state, OphthalmologyOPDComplaintAllergyHistSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST:
            return { ...state, OphthalmologyOPDComplaintAllergyHistUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST:
            return { ...state, OphthalmologyOPDComplaintAllergyHistDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC:
            return { ...state, OphthalmologyOPDComplaintDiabeticHistList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC:
            return { ...state, OphthalmologyOPDComplaintDiabeticHistSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC:
            return { ...state, OphthalmologyOPDComplaintDiabeticHistUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC:
            return { ...state, OphthalmologyOPDComplaintDiabeticHistDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX:
            return { ...state, OphthalmologyOPDComplaintHistTextBoxList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX:
            return { ...state, OphthalmologyOPDComplaintHistTextBoxSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX:
            return { ...state, OphthalmologyOPDComplaintHistTextBoxUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX:
            return { ...state, OphthalmologyOPDComplaintHistTextBoxDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTVISIONCHART2:
            return { ...state, OphthalmologyOPDOutVisionChartList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTVISIONCHART2:
            return { ...state, OphthalmologyOPDOutVisionChartSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTVISIONCHART2:
            return { ...state, OphthalmologyOPDOutVisionChartUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTVISIONCHART2:
            return { ...state, OphthalmologyOPDOutVisionChartDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTREFRACTIONS:
            return { ...state, OphthalmologyOPDRefractionList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTREFRACTIONS:
            return { ...state, OphthalmologyOPDRefractionSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTREFRACTIONS:
            return { ...state, OphthalmologyOPDRefractionUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTREFRACTIONS:
            return { ...state, OphthalmologyOPDRefractionDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTASCAN:
            return { ...state, OphthalmologyOPDAScanList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTASCAN:
            return { ...state, OphthalmologyOPDAScanSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTASCAN:
            return { ...state, OphthalmologyOPDAScanUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTASCAN:
            return { ...state, OphthalmologyOPDAScanDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTCOVERTESTEOM:
            return { ...state, OphthalmologyOPDCoverTestEOMList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM:
            return { ...state, OphthalmologyOPDCoverTestEOMSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM:
            return { ...state, OphthalmologyOPDCoverTestEOMUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOVERTESTEOM:
            return { ...state, OphthalmologyOPDCoverTestEOMDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTKERATOMETRY:
            return { ...state, OphthalmologyOPDKeratometryList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTKERATOMETRY:
            return { ...state, OphthalmologyOPDKeratometrySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTKERATOMETRY:
            return { ...state, OphthalmologyOPDKeratometryUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTKERATOMETRY:
            return { ...state, OphthalmologyOPDKeratometryDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTPACHYMETRY:
            return { ...state, OphthalmologyOPDPachymetryList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTPACHYMETRY:
            return { ...state, OphthalmologyOPDPachymetrySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPACHYMETRY:
            return { ...state, OphthalmologyOPDPachymetryUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPACHYMETRY:
            return { ...state, OphthalmologyOPDPachymetryDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTSYRINGING:
            return { ...state, OphthalmologyOPDSyringingList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTSYRINGING:
            return { ...state, OphthalmologyOPDSyringingSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTSYRINGING:
            return { ...state, OphthalmologyOPDSyringingUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTSYRINGING:
            return { ...state, OphthalmologyOPDSyringingDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTIOP:
            return { ...state, OphthalmologyOPDIOPList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTIOP:
            return { ...state, OphthalmologyOPDIOPSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTIOP:
            return { ...state, OphthalmologyOPDIOPUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTIOP:
            return { ...state, OphthalmologyOPDIOPDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTCOLORVISION:
            return { ...state, OphthalmologyOPDColorVisionList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTCOLORVISION:
            return { ...state, OphthalmologyOPDColorVisionSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOLORVISION:
            return { ...state, OphthalmologyOPDColorVisionUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOLORVISION:
            return { ...state, OphthalmologyOPDColorVisionDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTFUNDUS:
            return { ...state, OphthalmologyOPDFundusList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTFUNDUS:
            return { ...state, OphthalmologyOPDFundusSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTFUNDUS:
            return { ...state, OphthalmologyOPDFundusUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTFUNDUS:
            return { ...state, OphthalmologyOPDFundusDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTGLAUCOMA:
            return { ...state, OphthalmologyOPDGlaucomaList: action.payload.data, }
        case CREATEOPHTHALMOLOGYOPDOUTGLAUCOMA:
            return { ...state, OphthalmologyOPDGlaucomaSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTGLAUCOMA:
            return { ...state, OphthalmologyOPDGlaucomaUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTGLAUCOMA:
            return { ...state, OphthalmologyOPDGlaucomaDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRLASH:
            return { ...state, OphthalmologyOpdDrLashList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRLASH:
            return { ...state, OphthalmologyOpdDrLashList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRLASH:
            return { ...state, OphthalmologyOpdDrLashSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRLASH:
            return { ...state, OphthalmologyOpdDrLashUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRLASH:
            return { ...state, OphthalmologyOpdDrLashDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA:
            return { ...state, OphthalmologyOpdDrConjunctivaList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRCONJUNCTIVA:
            return { ...state, OphthalmologyOpdDrConjunctivaList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA:
            return { ...state, OphthalmologyOpdDrConjunctivaSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA:
            return { ...state, OphthalmologyOpdDrConjunctivaUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA:
            return { ...state, OphthalmologyOpdDrConjunctivaDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRCORNEA:
            return { ...state, OphthalmologyOpdDrCorneaList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRCORNEA:
            return { ...state, OphthalmologyOpdDrCorneaList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRCORNEA:
            return { ...state, OphthalmologyOpdDrCorneaSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRCORNEA:
            return { ...state, OphthalmologyOpdDrCorneaUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRCORNEA:
            return { ...state, OphthalmologyOpdDrCorneaDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRIRIS:
            return { ...state, OphthalmologyOpdDrIrisList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRIRIS:
            return { ...state, OphthalmologyOpdDrIrisList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRIRIS:
            return { ...state, OphthalmologyOpdDrIrisSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRIRIS:
            return { ...state, OphthalmologyOpdDrIrisUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRIRIS:
            return { ...state, OphthalmologyOpdDrIrisDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRPUPIL:
            return { ...state, OphthalmologyOpdDrPupilList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRPUPIL:
            return { ...state, OphthalmologyOpdDrPupilList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRPUPIL:
            return { ...state, OphthalmologyOpdDrPupilSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRPUPIL:
            return { ...state, OphthalmologyOpdDrPupilUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRPUPIL:
            return { ...state, OphthalmologyOpdDrPupilDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRLENSE:
            return { ...state, OphthalmologyOpdDrLenseList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRLENSE:
            return { ...state, OphthalmologyOpdDrLenseList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRLENSE:
            return { ...state, OphthalmologyOpdDrLenseSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRLENSE:
            return { ...state, OphthalmologyOpdDrLenseUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRLENSE:
            return { ...state, OphthalmologyOpdDrLenseDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION:
            return { ...state, OphthalmologyOpdDrGlassPrescriptionList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRGLASSPRESCRIPTION:
            return { ...state, OphthalmologyOpdDrGlassPrescriptionList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION:
            return { ...state, OphthalmologyOpdDrGlassPrescriptionSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION:
            return { ...state, OphthalmologyOpdDrGlassPrescriptionUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION:
            return { ...state, OphthalmologyOpdDrGlassPrescriptionDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRPACHYMETRY:
            return { ...state, OphthalmologyOpdDrPachymetryList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRPACHYMETRY:
            return { ...state, OphthalmologyOpdDrPachymetryList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY:
            return { ...state, OphthalmologyOpdDrPachymetrySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY:
            return { ...state, OphthalmologyOpdDrPachymetryUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRPACHYMETRY:
            return { ...state, OphthalmologyOpdDrPachymetryDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRIOP:
            return { ...state, OphthalmologyOpdDrIOPList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRIOP:
            return { ...state, OphthalmologyOpdDrIOPList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRIOP:
            return { ...state, OphthalmologyOpdDrIOPSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRIOP:
            return { ...state, OphthalmologyOpdDrIOPUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRIOP:
            return { ...state, OphthalmologyOpdDrIOPDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRDRAWING:
            return { ...state, OphthalmologyOpdDrDrawingList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRDRAWING:
            return { ...state, OphthalmologyOpdDrDrawingList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRDRAWING:
            return { ...state, OphthalmologyOpdDrDrawingSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRDRAWING:
            return { ...state, OphthalmologyOpdDrDrawingUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRDRAWING:
            return { ...state, OphthalmologyOpdDrDrawingDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRGONIOSCOPY:
            return { ...state, OphthalmologyOpdDrGonioscopyList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRGONIOSCOPY:
            return { ...state, OphthalmologyOpdDrGonioscopyList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY:
            return { ...state, OphthalmologyOpdDrGonioscopySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY:
            return { ...state, OphthalmologyOpdDrGonioscopyUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY:
            return { ...state, OphthalmologyOpdDrGonioscopyDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRDOCTOR:
            return { ...state, OphthalmologyOpdDrDoctorList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRDOCTOR:
            return { ...state, OphthalmologyOpdDrDoctorList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRDOCTOR:
            return { ...state, OphthalmologyOpdDrDoctorSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRDOCTOR:
            return { ...state, OphthalmologyOpdDrDoctorUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRDOCTOR:
            return { ...state, OphthalmologyOpdDrDoctorDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRDIAGNOSIS:
            return { ...state, OphthalmologyOpdDrDiagnosisList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRDIAGNOSIS:
            return { ...state, OphthalmologyOpdDrDiagnosisList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS:
            return { ...state, OphthalmologyOpdDrDiagnosisSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS:
            return { ...state, OphthalmologyOpdDrDiagnosisUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS:
            return { ...state, OphthalmologyOpdDrDiagnosisDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTDRSURGERYADVICE:
            return { ...state, OphthalmologyOpdDrSurgeryAdviceList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDDRSURGERYADVICE:
            return { ...state, OphthalmologyOpdDrSurgeryAdviceList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE:
            return { ...state, OphthalmologyOpdDrSurgeryAdviceSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE:
            return { ...state, OphthalmologyOpdDrSurgeryAdviceUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE:
            return { ...state, OphthalmologyOpdDrSurgeryAdviceDeleteStatus: action.payload.success, }

        case GETOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS:
            return { ...state, OphthalmologyOpdCounsSurgeryDetailsList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDCOUNSSURGERYDETAILS:
            return { ...state, OphthalmologyOpdCounsSurgeryDetailsList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS:
            return { ...state, OphthalmologyOpdCounsSurgeryDetailsSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS:
            return { ...state, OphthalmologyOpdCounsSurgeryDetailsUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS:
            return { ...state, OphthalmologyOpdCounsSurgeryDetailsDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM:
            return { ...state, OphthalmologyOpdCounsCounsellorFormList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDCOUNSCOUNSELLORFORM:
            return { ...state, OphthalmologyOpdCounsCounsellorFormList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM:
            return { ...state, OphthalmologyOpdCounsCounsellorFormSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM:
            return { ...state, OphthalmologyOpdCounsCounsellorFormUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM:
            return { ...state, OphthalmologyOpdCounsCounsellorFormDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE:
            return { ...state, OphthalmologyOpdCounsEstimateList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDCOUNSEASTIMATE:
            return { ...state, OphthalmologyOpdCounsEstimateList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE:
            return { ...state, OphthalmologyOpdCounsEstimateSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE:
            return { ...state, OphthalmologyOpdCounsEstimateUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE:
            return { ...state, OphthalmologyOpdCounsEstimateDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE:
            return { ...state, OphthalmologyOpdCounsScheduleList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDCOUNSSCHEDULE:
            return { ...state, OphthalmologyOpdCounsScheduleList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE:
            return { ...state, OphthalmologyOpdCounsScheduleSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE:
            return { ...state, OphthalmologyOpdCounsScheduleUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE:
            return { ...state, OphthalmologyOpdCounsScheduleDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION:
            return { ...state, OphthalmologyOpdCounsInstructionsList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDCOUNSINSTRUCTION:
            return { ...state, OphthalmologyOpdCounsInstructionsList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION:
            return { ...state, OphthalmologyOpdCounsInstructionsSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION:
            return { ...state, OphthalmologyOpdCounsInstructionsUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION:
            return { ...state, OphthalmologyOpdCounsInstructionsDeleteStatus: action.payload.success, }

        case GETOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS:
            return { ...state, OphthalmologyOpdProcedureNewGlassList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDPROCEDURENEWGLASS:
            return { ...state, OphthalmologyOpdProcedureNewGlassList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS:
            return { ...state, OphthalmologyOpdProcedureNewGlassSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS:
            return { ...state, OphthalmologyOpdProcedureNewGlassUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS:
            return { ...state, OphthalmologyOpdProcedureNewGlassDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE:
            return { ...state, OphthalmologyOpdProcedureContactLenseList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDPROCEDURECONTACTLENSE:
            return { ...state, OphthalmologyOpdProcedureContactLenseList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE:
            return { ...state, OphthalmologyOpdProcedureContactLenseSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE:
            return { ...state, OphthalmologyOpdProcedureContactLenseUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE:
            return { ...state, OphthalmologyOpdProcedureContactLenseDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY:
            return { ...state, OphthalmologyOpdProcedureRefractiveSurgeryList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDPROCEDUREREFRACTIVESURGERY:
            return { ...state, OphthalmologyOpdProcedureRefractiveSurgeryList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY:
            return { ...state, OphthalmologyOpdProcedureRefractiveSurgerySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY:
            return { ...state, OphthalmologyOpdProcedureRefractiveSurgeryUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY:
            return { ...state, OphthalmologyOpdProcedureRefractiveSurgeryDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY:
            return { ...state, OphthalmologyOpdProcedureContractSurgeryList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDPROCEDURECONTRACTSURGERY:
            return { ...state, OphthalmologyOpdProcedureContractSurgeryList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY:
            return { ...state, OphthalmologyOpdProcedureContractSurgerySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY:
            return { ...state, OphthalmologyOpdProcedureContractSurgeryUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY:
            return { ...state, OphthalmologyOpdProcedureContractSurgeryDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY:
            return { ...state, OphthalmologyOpdProcedureCornealSurgeryList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDPROCEDURECORNEALSURGERY:
            return { ...state, OphthalmologyOpdProcedureCornealSurgeryList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY:
            return { ...state, OphthalmologyOpdProcedureCornealSurgerySaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY:
            return { ...state, OphthalmologyOpdProcedureCornealSurgeryUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY:
            return { ...state, OphthalmologyOpdProcedureCornealSurgeryDeleteStatus: action.payload.success, }
        case GETOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE:
            return { ...state, OphthalmologyOpdProcedureLasikProcedureList: action.payload.data, }
        case CLEAROPTHALMOLOGYOPDPROCEDURELASIKPROCEDURE:
            return { ...state, OphthalmologyOpdProcedureLasikProcedureList: [], };
        case CREATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE:
            return { ...state, OphthalmologyOpdProcedureLasikProcedureSaveStatus: action.payload.success, }
        case UPDATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE:
            return { ...state, OphthalmologyOpdProcedureLasikProcedureUpdateStatus: action.payload.success, }
        case DELETEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE:
            return { ...state, OphthalmologyOpdProcedureLasikProcedureDeleteStatus: action.payload.success, }

        case CLEAROPTHALMOLOGYOPDCHIEFCOMPLAINT:
            return { ...state, OphthalmologyOPDComplaintChiefHistList: [], };
        case CLEAROPTHALMOLOGYOPDPASTOCCULARHIST:
            return { ...state, OphthalmologyOPDComplaintPastOccularHistList: [], };
        case CLEAROPTHALMOLOGYOPDSYSTEMICILLNESS:
            return { ...state, OphthalmologyOPDComplaintSystemicIllnessList: [], };
        case CLEAROPTHALMOLOGYOPDFAMILYHIST:
            return { ...state, OphthalmologyOPDComplaintFamilyHistList: [], };
        case CLEAROPTHALMOLOGYOPDALLERGYHIST:
            return { ...state, OphthalmologyOPDComplaintAllergyHistList: [], };
        case CLEAROPTHALMOLOGYOPDDIABETIC:
            return { ...state, OphthalmologyOPDComplaintDiabeticHistList: [], };
        case CLEAROPTHALMOLOGYOPDCOMPLAINTTEXTBOX:
            return { ...state, OphthalmologyOPDComplaintHistTextBoxList: [], };
        case CLEAROPTHALMOLOGYOPDVISION:
            return { ...state, OphthalmologyOPDOutVisionChartList: [], };
        case CLEAROPTHALMOLOGYOPDREFRACTION:
            return { ...state, OphthalmologyOPDRefractionList: [], };
        case CLEAROPTHALMOLOGYOPDPRESCRIPTION:
            return { ...state, EyeOphthalmologyGlassLensePrescriptionList: [], };
        case CLEAROPTHALMOLOGYOPDASCAN:
            return { ...state, OphthalmologyOPDAScanList: [], };
        case CLEAROPTHALMOLOGYOPDCOVERTESTEOM:
            return { ...state, OphthalmologyOPDCoverTestEOMList: [], };
        case CLEAROPTHALMOLOGYOPDKERATOMETRY:
            return { ...state, OphthalmologyOPDKeratometryList: [], };
        case CLEAROPTHALMOLOGYOPDPACHYMETRY:
            return { ...state, OphthalmologyOPDPachymetryList: [], };
        case CLEAROPTHALMOLOGYOPDSYRINGING:
            return { ...state, OphthalmologyOPDSyringingList: [], };
        case CLEAROPTHALMOLOGYOPDOUTIOP:
            return { ...state, OphthalmologyOPDIOPList: [], };
        case CLEAROPTHALMOLOGYOPDCOLORVISION:
            return { ...state, OphthalmologyOPDColorVisionList: [], };
        case CLEAROPTHALMOLOGYOPDFUNDUS:
            return { ...state, OphthalmologyOPDFundusList: [], };
        case CLEAROPTHALMOLOGYOPDGLAUCOMA:
            return { ...state, OphthalmologyOPDGlaucomaList: [], };
        case CLEAROPTHALMOLOGYOPDDRLASH:
            return { ...state, OphthalmologyOPDGlaucomaList: [], };


        default:
            return state;
    }
}
